module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium_1.350b1203.eot";